import styled from "styled-components";

export const StyledPickup = styled.div`
  .pickup-address,
  .delivery-address {
    font-size: 12px;
    color: var(--rms-v2-text-body);
    margin-top: 10px;
  }

  .pickup-address {
    white-space: break-spaces;
    text-overflow: initial;
    overflow: visible;
    max-width: 100%;
    margin: 0;
  }

  .pickup-address-line {
    display: block;
  }

  .pickup-address-row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-top: 8px;
  }

  .pickup-address-icon {
    height: 16px;
    margin-top: 2px;
    width: 16px;
  }

  .ship-back-panel {
    background: ${(props) => `${props.$primaryColor || "#000000"}33`};
    border: 1px dashed ${(props) => props.$primaryColor || "currentColor"};
    margin-top: 10px;
    padding: 6px;
  }

  .change {
    font-size: 16px;
    color: var(--rms-v2-text-muted);
  }

  .pickup {
    font-weight: 700;
    color: var(--rms-v2-text-body);
    font-size: 20px;
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
  }

  .ship-back {
    color: var(--rms-v2-text-body);
    font-size: 18px;
  }

  .customer-preference {
    .form-control-preference {
      margin: 0;
      flex-direction: row;
      align-items: center;
      gap: 8px;

      .MuiFormGroup-root {
        margin-left: 0;
        flex-direction: row;
      }

      .title {
        color: var(--rms-v2-text-title);
        font-size: 12px;
        font-weight: 700;
        line-height: 1.3;
      }

      .MuiFormControlLabel-root {
        margin: 0;
      }

      .MuiFormControlLabel-label {
        color: var(--rms-v2-text-title);
        font-size: 12px;
        font-weight: 600;
        line-height: 1.3;
      }

      .MuiRadio-root {
        padding: 2px;
      }

      .MuiRadio-root svg {
        width: 16px;
        height: 16px;
      }
    }
  }

  `;
